/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ metres: NonNullable<unknown> }} Offline_Set_MetresInputs */

const en_us2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_br2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const es_419_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const pt_pt2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const fr_fr2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const de_de2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

const it_it2_offline_set_metres = /** @type {(inputs: Offline_Set_MetresInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.metres} m`)
};

/**
* | output |
* | --- |
* | "{metres} m" |
*
* @param {Offline_Set_MetresInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_set_metres = /** @type {((inputs: Offline_Set_MetresInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Set_MetresInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_set_metres(inputs)
	if (locale === "es-419") return es_419_offline_set_metres(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_set_metres(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_set_metres(inputs)
	if (locale === "de-DE") return de_de2_offline_set_metres(inputs)
	if (locale === "it-IT") return it_it2_offline_set_metres(inputs)
	return en_us2_offline_set_metres(inputs)
});
export { offline_set_metres as "offline.set_metres" }